<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 13H5v-2h14v2z"/>
    </svg>
</template>

<script>
export default {
    name: 'MinusIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
